export default (function (value) {
  return value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isUndefined.js
// module id = 1453
// module chunks = 1